/*
  customsirge_product_slider.js
  Purpose:  Sets the initial scroll position of the pdp_related_products
            preset's full-bleed row so it opens "at its centred position"
            (spec.json motion.decision_0016.carousel) instead of flush left —
            a plain scrollLeft jump, no scroll animation (decision 0016:
            "no animation on load"). When the row has nothing to scroll (its
            content already fits, e.g. exactly 4 products), it switches
            itself to justify-content:center instead, so that case reads
            exactly like home_crowd_favourites' own plain centred row
            (BRIEF.md: "with exactly 4 products the row is centred like
            Home") without a second markup/CSS path.
            Desktop (>=750px) ONLY — the mobile v0.2 layout (decision 0013)
            is a plain swipe row that starts flush at card 1 (page x 40,
            BRIEF.md must_haves.mobile_420_v02.row), not a centred carousel;
            running this below 750px scrolled straight past card 1 on load
            (caught in the build's own smoke screenshot review — shot_420.png
            opened mid-row instead of at card 1).
  Spec:     .claude/knowledge/extraction/figma/sections/pdp_related_products/
            spec.json → motion.design_implies / decision_0016.carousel;
            BRIEF.md "Row: ... initial scroll centred ... (scrollLeft =
            (scrollWidth − clientWidth) / 2 on init ...)".
  Data:     none — reads only the DOM (scrollWidth/clientWidth) of the
            element it is attached to.
  Renders:  nothing; sets `scrollLeft` (or `style.justifyContent`) on
            `[data-customsirge-center-scroll]`
            (.customsirge-pdp-related-products__row, written by
            sections/customsirge_product_slider.liquid).
  Owns:     window.Customsirge components['pdp-related-products-row']. No
            CSS namespace of its own (assets/customsirge_product_slider.css
            owns the row's static rules).
  Loaded:   by sections/customsirge_product_slider.liquid itself, only when
            section.settings.spec_key == 'pdp_related_products'.
  Owner:    figma-builder (pdp_related_products) — 2026-09-15
*/

(function () {
  'use strict';

  if (!window.Customsirge || !window.Customsirge.register) return;

  // 2026-10-06: Crowd Favourites filter tabs (off by default; section setting
  // "Show filter tabs"). A tab with an empty data-cf-tab shows every card.
  Customsirge.register('crowd-favourites-tabs', {
    selector: '[data-customsirge-cf-tabs]',
    init: function (list) {
      var section = list.closest('.customsirge-home-crowd-favourites');
      var row = section && section.querySelector('.customsirge-home-crowd-favourites__row');
      if (!row) return undefined;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-cf-tab]'));
      function show(tab) {
        var handle = tab.getAttribute('data-cf-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        Array.prototype.forEach.call(row.children, function (slide) {
          var own = ' ' + (slide.getAttribute('data-cf-collections') || '') + ' ';
          slide.hidden = !!handle && own.indexOf(' ' + handle + ' ') === -1;
        });
        row.scrollLeft = 0;
      }
      function onClick(e) {
        var tab = e.target.closest('[data-cf-tab]');
        if (tab) show(tab);
      }
      list.addEventListener('click', onClick);
      return function () { list.removeEventListener('click', onClick); };
    },
  });

  Customsirge.register('pdp-related-products-row', {
    selector: '[data-customsirge-center-scroll]',
    init: function (el) {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      var max = el.scrollWidth - el.clientWidth;
      if (max > 0) {
        el.scrollLeft = max / 2;
      } else {
        el.style.justifyContent = 'center';
      }
    },
  });
})();
